import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api",
});

// Attach token automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Global safe response wrapper
export const safeRequest = async (promise) => {
  try {
    const res = await promise;
    return { data: res?.data ?? null, error: null };
  } catch (err) {
    return {
      data: null,
      error:
        err?.response?.data?.detail ||
        err?.message ||
        "Something went wrong",
    };
  }
};

// Safe error formatter (ONLY ONCE — fixes your current bug)
export const formatApiErrorDetail = (detail) => {
  if (!detail) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || e).join(" ");
  if (typeof detail === "object") return JSON.stringify(detail);
  return "Unknown error";
};

export default api;